export { default, ImageQuestionProps } from "./ImageQuestion";
export { ImageQuestionWrap } from "./styles";
